module.exports = __webpack_public_path__ + "static/media/facebook.3d3d0b30.svg";